const { __ } = wp.i18n;
const { InspectorControls, InnerBlocks, TextAlignmentControl } = wp.blockEditor;
const { useState, useEffect } = wp.element;
const { __experimentalHeading, TextControl, PanelBody, __experimentalToggleGroupControl, __experimentalBorderBoxControl, Icon, SelectControl, __experimentalToggleGroupControlOptionIcon, __experimentalDivider, BaseControl, Flex, FlexBlock, TabPanel } = wp.components;
import { useSelect } from '@wordpress/data';
import './sizing.css';
import { setAttributesResponsive } from '../../block/functions.js';
import DisplayControl from '../display/display.js';

const SizingControl = ({ attributes, setAttributes, blockName }) => {
    const currentDevice = useSelect((select) => {
        return select('core/edit-post').__experimentalGetPreviewDeviceType();
    }, []);
    const device = currentDevice.toLowerCase();
    const deviceString = device === 'desktop' ? '' : `:${device}`;

    return (    
        <>
            <__experimentalHeading>SIZING</__experimentalHeading>
            <TextControl
                label="Width"
                onChange={(newValue) => setAttributesResponsive('width', newValue, device, setAttributes, attributes)}
                value={attributes?.['width' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <TextControl
                label="Min Width"
                onChange={(newValue) => setAttributesResponsive('min-width', newValue, device, setAttributes, attributes)}
                value={attributes?.['min-width' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <TextControl
                label="Max Width"
                onChange={(newValue) => setAttributesResponsive('max-width', newValue, device, setAttributes, attributes)}
                value={attributes?.['max-width' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <TextControl
                label="Height"
                onChange={(newValue) => setAttributesResponsive('height', newValue, device, setAttributes, attributes)}
                value={attributes?.['height' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <TextControl
                label="Min Height"
                onChange={(newValue) => setAttributesResponsive('min-height', newValue, device, setAttributes, attributes)}
                value={attributes?.['min-height' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <TextControl
                label="Max Height"
                onChange={(newValue) => setAttributesResponsive('max-height', newValue, device, setAttributes, attributes)}
                value={attributes?.['max-height' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <__experimentalDivider />
            <__experimentalHeading>POSITIONING</__experimentalHeading>
            <SelectControl
                label="Position"
                options={[
                    { label: 'Default', value: ''},
                    { label: 'Static', value: 'static' },
                    { label: 'Relative', value: 'relative' },
                    { label: 'Fixed', value: 'fixed' },
                    { label: 'Absolute', value: 'absolute' },
                    { label: 'Sticky', value: 'sticky' }
                ]}
                labelPosition="edge"
                className="softlite-select-control"
                onChange={(newValue) => setAttributesResponsive('position', newValue, device, setAttributes, attributes)}
                value={attributes?.['position' + deviceString]}
            />
            <TextControl
                label="Top"
                onChange={(newValue) => setAttributesResponsive('top', newValue, device, setAttributes, attributes)}
                value={attributes?.['top' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <TextControl
                label="Right"
                onChange={(newValue) => setAttributesResponsive('right', newValue, device, setAttributes, attributes)}
                value={attributes?.['right' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <TextControl
                label="Bottom"
                onChange={(newValue) => setAttributesResponsive('bottom', newValue, device, setAttributes, attributes)}
                value={attributes?.['bottom' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <TextControl
                label="Left"
                onChange={(newValue) => setAttributesResponsive('left', newValue, device, setAttributes, attributes)}
                value={attributes?.['left' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <TextControl
                label="Z-Index"
                onChange={(newValue) => setAttributesResponsive('z-index', newValue, device, setAttributes, attributes)}
                value={attributes?.['z-index' + deviceString]}
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <__experimentalDivider />
            <__experimentalHeading>MISC</__experimentalHeading>
            {blockName !== 'softlite-io-integration/div' && (
                <DisplayControl
                    attributes={attributes}
                    setAttributes={setAttributes}
                />
            )}
            <SelectControl
                label="Visibility"
                options={[
                    { label: 'Default', value: ''},
                    { label: 'Visible', value: 'visible' },
                    { label: 'Hidden', value: 'hidden' },
                    { label: 'Collapse', value: 'collapse' }
                ]}
                labelPosition="edge"
                className="softlite-select-control"
                onChange={(newValue) => setAttributesResponsive('visibility', newValue, device, setAttributes, attributes)}
                value={attributes?.['visibility' + deviceString]}
            />
            <TextControl
                label="Overflow"
                className="softlite-sizing-text-control softlite-sizing-text-center"
                onChange={(newValue) => setAttributesResponsive('overflow', newValue, device, setAttributes, attributes)}
                value={attributes?.['overflow' + deviceString]}
            />
            <TextControl
                label="Opacity"
                className="softlite-sizing-text-control softlite-sizing-text-center"
                placeholder="1"
                onChange={(newValue) => setAttributesResponsive('opacity', newValue, device, setAttributes, attributes)}
                value={attributes?.['opacity' + deviceString]}
            />
            <TextControl // Trong bricks là select
                label="Cursor"
                className="softlite-sizing-text-control softlite-sizing-text-center"
                placeholder="auto"
                onChange={(newValue) => setAttributesResponsive('cursor', newValue, device, setAttributes, attributes)}
                value={attributes?.['cursor' + deviceString]}
            />
            <SelectControl
                label="Isolation"
                options={[  
                    { label: 'Default'},
                    { label: 'Auto', value: 'auto' },
                    { label: 'Isolate', value: 'isolate' },
                ]}
                labelPosition="edge"
                className="softlite-select-control"
                onChange={(newValue) => setAttributesResponsive('isolation', newValue, device, setAttributes, attributes)}
                value={attributes?.['isolation' + deviceString]}
            />
            <TextControl
                label="Pointer events"
                className="softlite-sizing-text-control softlite-sizing-text-center"
                placeholder="auto"
                onChange={(newValue) => setAttributesResponsive('pointer-events', newValue, device, setAttributes, attributes)}
                value={attributes?.['pointer-events' + deviceString]}
            />
        </>
    );
}

export default SizingControl;